import "./CaptionedVideo.css";
import { getCloudFrontVideo } from "../../util/cloudfront";
import MuxPlayer from "@mux/mux-player-react";

export default function CaptionedVideo({ video }) {
    let finalSource = "";
    if (video.videoSource === "url" && video.videoURL) {
        finalSource = video.videoURL;
    } else if (video.videoSource === "cloudfront" && video.videoFileName) {
        finalSource = getCloudFrontVideo(video.videoBucketName, video.videoFileName);
    }
    if (!finalSource) {
        return null;
    }

    // if youtube video, use regular iframe
    if (finalSource.includes("youtube.com") || finalSource.includes("youtu.be")) {
        const videoId = finalSource.split("v=")[1] || finalSource.split("/").pop();
        const embedURL = `https://www.youtube.com/embed/${videoId.split("?")[0]}`;

        return (
            <div className="captionedVideo">
                <div className="videoContainer">
                    <iframe
                        src={embedURL}
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    ></iframe>
                </div>
                {video.caption && <p className="caption">{video.caption}</p>}
            </div>
        );
    }

    // otherwise, use Mux player
    return (
        <div className="captionedVideo">
            <MuxPlayer
                src={finalSource}
                metadata={{
                    video_title: video.caption || "Blog Video",
                }}
                controls
                style={{ width: "100%", height: "auto" }}
            />
            {video.caption && <p className="caption">{video.caption}</p>}
        </div>
    );
}
